import { BrowserRouter, Route, Routes } from "react-router-dom";
import AuthProvider from "@/context/AuthProvider";
import ProtectedRoute from "@/components/ProtectedRoute/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute/AdminRoute";
import AuthenticatedRoute from "@/components/AuthenticatedRoute/AuthenticatedRoute";
import AppShell from "@/components/AppShell/AppShell";
import SignInPage from "@/pages/SignInPage/SignInPage";
import SignUpPage from "@/pages/SignUpPage/SignUpPage";
import HomePage from "@/pages/HomePage/HomePage";
import MyPropertiesPage from "@/pages/MyPropertiesPage/MyPropertiesPage";
import MyBookingsPage from "@/pages/MyBookingsPage/MyBookingsPage";
import CompaniesPage from "@/pages/CompaniesPage/CompaniesPage";
import CreateCompanyPage from "@/pages/CreateCompanyPage/CreateCompanyPage";
import CreateUserPage from "@/pages/CreateUserPage/CreateUserPage";
import ProfilePage from "@/pages/ProfilePage/ProfilePage";
import CompanyLayout from "@/pages/CompanyLayout/CompanyLayout";
import CompanyOverviewTab from "@/pages/CompanyOverviewTab/CompanyOverviewTab";
import CompanyUsersTab from "@/pages/CompanyUsersTab/CompanyUsersTab";
import CompanyPropertiesTab from "@/pages/CompanyPropertiesTab/CompanyPropertiesTab";
import CompanyBookingsTab from "@/pages/CompanyBookingsTab/CompanyBookingsTab";
import EditCompanyPage from "@/pages/EditCompanyPage/EditCompanyPage";
import PropertiesPage from "@/pages/PropertiesPage/PropertiesPage";
import CreatePropertyPage from "@/pages/CreatePropertyPage/CreatePropertyPage";
import EditPropertyPage from "@/pages/EditPropertyPage/EditPropertyPage";
import PropertyDetailsPage from "@/pages/PropertyDetailsPage/PropertyDetailsPage";
import CreateBookingPage from "@/pages/CreateBookingPage/CreateBookingPage";
import ExtrasPage from "@/pages/ExtrasPage/ExtrasPage";
import CreateExtraPage from "@/pages/CreateExtraPage/CreateExtraPage";
import EditExtraPage from "@/pages/EditExtraPage/EditExtraPage";
import PlacesPage from "@/pages/PlacesPage/PlacesPage";
import CreatePlacePage from "@/pages/CreatePlacePage/CreatePlacePage";
import EditPlacePage from "@/pages/EditPlacePage/EditPlacePage";
import UsersPage from "@/pages/UsersPage/UsersPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<AppShell />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/my-properties" element={<MyPropertiesPage />} />
              <Route path="/my-bookings" element={<MyBookingsPage />} />
              <Route path="/properties/new" element={<CreatePropertyPage />} />
            </Route>
          </Route>

          <Route element={<AdminRoute />}>
            <Route element={<AppShell />}>
              <Route path="/companies" element={<CompaniesPage />} />
              <Route path="/companies/new" element={<CreateCompanyPage />} />
              <Route path="/companies/:id" element={<CompanyLayout />}>
                <Route index element={<CompanyOverviewTab />} />
                <Route path="users" element={<CompanyUsersTab />} />
                <Route path="properties" element={<CompanyPropertiesTab />} />
                <Route path="bookings" element={<CompanyBookingsTab />} />
              </Route>
              <Route
                path="/companies/:id/edit"
                element={<EditCompanyPage />}
              />
              <Route
                path="/companies/:id/properties/new"
                element={<CreatePropertyPage />}
              />
              <Route path="/properties" element={<PropertiesPage />} />
              <Route path="/extras" element={<ExtrasPage />} />
              <Route path="/extras/new" element={<CreateExtraPage />} />
              <Route path="/extras/:id/edit" element={<EditExtraPage />} />
              <Route path="/places" element={<PlacesPage />} />
              <Route path="/places/new" element={<CreatePlacePage />} />
              <Route path="/places/:id/edit" element={<EditPlacePage />} />
              <Route path="/users" element={<UsersPage />} />
            </Route>
          </Route>

          <Route element={<AuthenticatedRoute />}>
            <Route element={<AppShell />}>
              <Route path="/properties/:id" element={<PropertyDetailsPage />} />
              <Route
                path="/properties/:id/edit"
                element={<EditPropertyPage />}
              />
              <Route
                path="/properties/:id/bookings/new"
                element={<CreateBookingPage />}
              />
              <Route path="/users/new" element={<CreateUserPage />} />
              <Route path="/profile" element={<ProfilePage />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
